import {
  ADD_SECURITY_GROUP_FAIL,
  ADD_SECURITY_GROUP_SUCCESS,
  ADDING_SECURITY_GROUP,
  DELETING_SECURITY_GROUP,
  FETCH_APPS_FAIL,
  FETCH_APPS_SUCCESS,
  FETCH_PERMISSIONS_FAIL,
  FETCH_PERMISSIONS_SUCCESS,
  FETCH_FEATURES_FAIL,
  FETCH_FEATURES_SUCCESS,
  FETCH_SECURITY_GROUP_FAILED,
  FETCH_SECURITY_GROUP_SUCCESS,
  FETCH_SECURITY_GROUPS_FAILED,
  FETCH_SECURITY_GROUPS_SUCCESS,
  FETCHING_APPS,
  FETCHING_PERMISSIONS,
  FETCHING_FEATURES,
  FETCHING_SECURITY_GROUP,
  FETCHING_SECURITY_GROUPS, PATCH_SECURITY_GROUP_FAILED, PATCH_SECURITY_GROUP_SUCCESS, PATCHING_SECURITY_GROUP,
  RESET_OPERATION_STATUS,
  SECURITY_GROUP_DELETE_FAIL,
  SECURITY_GROUP_DELETE_SUCCESS,
  TOGGLE_SECURITY_MODAL, UPDATE_APPS_FAILED, UPDATE_APPS_SUCCESS,
  UPDATE_PERMISSIONS_FAILED,
  UPDATE_PERMISSIONS_SUCCESS,
  UPDATE_SECURITY_GROUP, UPDATE_USERS_FAILED,
  UPDATE_USERS_SUCCESS, UPDATING_APPS,
  UPDATING_PERMISSIONS,
  UPDATING_USERS,
  UPDATE_APPS,
  FORM_CHANGE, ADD_APP, REMOVE_APP
} from "../actions/SecurityGroupActions";
import { Statuses } from "../constants/Enums";
import _ from 'lodash';

export default function reducer(state = {
  permissions: [],
  securityGroup: {},
  defaultSecurityGroup: {
    name: "",
    description: "",
    permissions: []
  },
  features: [],
  isFetching: false,
  apps: [],
  activeApps: {},
  isModalOpen: false,
  err: null,
  operationStatus: Statuses.NOT_STARTED,
  securityGroups: [],
  securityGroupUpdateStatus: Statuses.NOT_STARTED,
  permissionUpdateStatus: Statuses.NOT_STARTED,
  usersUpdateStatus: Statuses.NOT_STARTED,
  appUpdateStatus: Statuses.NOT_STARTED,
}, action) {
  switch (action.type) {

    case FETCHING_SECURITY_GROUPS: {
      return {
        ...state,
        isFetching: true,
        error: null
      };
    }

    case FETCH_SECURITY_GROUPS_SUCCESS: {
      return {
        ...state,
        isFetching: false,
        securityGroups: action.payload,
        error: null
      }
    }

    case FETCH_SECURITY_GROUPS_FAILED: {
      return {
        ...state,
        isFetching: false,
        roles: [],
        securityGroups: [],
        error: action.payload
      }
    }

    case UPDATE_SECURITY_GROUP: {
      let securityGroup = { ...action.payload };
      return { ...state, securityGroup };
    }
    case FETCHING_PERMISSIONS: {
      return { ...state, isFetching: true, permissions: null };
    }
    case FETCH_PERMISSIONS_SUCCESS: {
      let featureIds = state.features.map(feature => feature.id);
      return {
        ...state,
        permissions: action.payload.filter(permission => (featureIds.includes(permission.featureId) || permission.featureId == null)),
        isFetching: false
      };
    }
    case FETCH_PERMISSIONS_FAIL: {
      return { ...state, permissions: [], err: action.payload, isFetching: false };
    }
    case FETCHING_FEATURES: {
      return { ...state, isFetching: true };
    }
    case FETCH_FEATURES_SUCCESS: {
      return { ...state, features: action.payload, isFetching: false };
    }
    case FETCH_FEATURES_FAIL: {
      return { ...state, features: [], err: action.payload, isFetching: false };
    }
    case FETCHING_APPS: {
      return { ...state, isFetching: true, err: null };
    }
    case FETCH_APPS_SUCCESS: {
      return { ...state, isFetching: false, err: null, apps: action.payload };
    }
    case FETCH_APPS_FAIL: {
      return { ...state, isFetching: false, err: action.payload, apps: [] };
    }
    case TOGGLE_SECURITY_MODAL: {
      return { ...state, isModalOpen: !state.isModalOpen };
    }
    case ADDING_SECURITY_GROUP: {
      return { ...state, isFetching: true, err: null };
    }
    case ADD_SECURITY_GROUP_SUCCESS: {
      return { ...state, isFetching: false, err: null, operationStatus: Statuses.SUCCESS }
    }
    case ADD_SECURITY_GROUP_FAIL: {
      return { ...state, isFetching: false, err: action.payload, operationStatus: Statuses.FAILURE };
    }
    case RESET_OPERATION_STATUS: {
      return {
        ...state,
        operationStatus: Statuses.NOT_STARTED,
        securityGroupUpdateStatus: Statuses.NOT_STARTED,
        permissionUpdateStatus: Statuses.NOT_STARTED,
        usersUpdateStatus: Statuses.NOT_STARTED,
        appUpdateStatus: Statuses.NOT_STARTED,
        securityGroup: {},
        activeApps: {}
      };
    }
    case DELETING_SECURITY_GROUP: {
      return { ...state, operationStatus: Statuses.NOT_STARTED, isFetching: true, err: null };
    }
    case SECURITY_GROUP_DELETE_SUCCESS: {
      let id = action.payload;
      let securityGroups = state.securityGroups;
      securityGroups.forEach((securityGroup, i) => {
        if (securityGroup.id === id) {
          securityGroups.splice(i, 1);
        }
      });
      return { ...state, operationStatus: Statuses.SUCCESS, isFetching: false, err: null, securityGroups };
    }

    case SECURITY_GROUP_DELETE_FAIL: {
      return { ...state, operationStatus: Statuses.FAILURE, isFetching: false, err: action.payload };
    }
    case FETCHING_SECURITY_GROUP: {
      return { ...state, isFetching: true, err: null, securityGroup: {} };
    }
    case FETCH_SECURITY_GROUP_SUCCESS: {
      return { ...state, isFetching: false, err: null, securityGroup: action.payload };
    }
    case FETCH_SECURITY_GROUP_FAILED: {
      return { ...state, isFetching: false, err: action.payload, securityGroup: {} };
    }
    case PATCHING_SECURITY_GROUP: {
      let { securityGroupUpdateStatus } = state;
      securityGroupUpdateStatus = Statuses.NOT_STARTED;
      return { ...state, isFetching: true, err: null, securityGroupUpdateStatus }
    }
    case PATCH_SECURITY_GROUP_SUCCESS: {
      let { securityGroupUpdateStatus, securityGroup } = state;
      securityGroup.version = action.payload;
      securityGroupUpdateStatus = Statuses.SUCCESS;
      return { ...state, err: null, securityGroupUpdateStatus, securityGroup };
    }
    case PATCH_SECURITY_GROUP_FAILED: {
      let { securityGroupUpdateStatus } = state;
      securityGroupUpdateStatus = Statuses.FAILURE;
      return { ...state, isFetching: false, err: action.payload, securityGroupUpdateStatus }
    }
    case UPDATING_PERMISSIONS: {
      let { permissionUpdateStatus } = state;
      permissionUpdateStatus = Statuses.NOT_STARTED;
      return { ...state, err: null, permissionUpdateStatus }
    }
    case UPDATE_PERMISSIONS_SUCCESS: {
      let { permissionUpdateStatus, securityGroup } = state;
      securityGroup.version = action.payload;
      permissionUpdateStatus = Statuses.SUCCESS;
      return { ...state, err: null, permissionUpdateStatus, securityGroup };
    }
    case UPDATE_PERMISSIONS_FAILED: {
      let { permissionUpdateStatus } = state;
      permissionUpdateStatus = Statuses.FAILURE;
      return { ...state, isFetching: false, err: action.payload, permissionUpdateStatus }
    }
    case UPDATING_USERS: {
      let { usersUpdateStatus } = state;
      usersUpdateStatus = Statuses.NOT_STARTED;
      return { ...state, usersUpdateStatus }
    }
    case UPDATE_USERS_SUCCESS: {
      return {
        ...state,
        usersUpdateStatus: Statuses.SUCCESS,
        securityGroup: {...state.securityGroup, ...action.payload} ,
        securityGroups: getSecurityGroupsWithUpdatedUsers(action.payload.id, state.securityGroups, action.payload.users)
      }
    }
    case UPDATE_USERS_FAILED: {
      let { usersUpdateStatus } = state;
      usersUpdateStatus = Statuses.FAILURE;
      return { ...state, isFetching: false, err: action.payload, usersUpdateStatus }
    }
    //Update apps for API call
    case UPDATING_APPS: {
      let { appUpdateStatus } = state;
      appUpdateStatus = Statuses.NOT_STARTED;
      return { ...state, appUpdateStatus };
    }
    case UPDATE_APPS_SUCCESS: {
      let { appUpdateStatus, securityGroup } = state;
      appUpdateStatus = Statuses.SUCCESS;
      securityGroup.version = action.payload;
      return { ...state, isFetching: false, securityGroup, appUpdateStatus };
    }
    case UPDATE_APPS_FAILED: {
      let { appUpdateStatus, err } = state;
      appUpdateStatus = Statuses.FAILURE;
      err = action.payload;
      return { ...state, err, appUpdateStatus };
    }

    //Update apps in security group.. NOT API
    case UPDATE_APPS: {
      let activeApps = { ...action.payload };
      let securityGroup = { ...state.securityGroup };
      securityGroup.appIds = Object.keys(activeApps);
      return { ...state, securityGroup, activeApps };
    }

    case ADD_APP: {
      let appId = action.payload;
      let securityGroup = Object.assign({}, state.securityGroup);
      securityGroup.appIds.push(appId);
      let activeApps = Object.assign({}, state.activeApps);
      activeApps[appId] = appId;
      return { ...state, securityGroup, activeApps };
    }

    case REMOVE_APP: {
      let appId = action.payload;
      let securityGroup = Object.assign({}, state.securityGroup);
      securityGroup.appIds.splice(securityGroup.appIds.indexOf(appId), 1);
      let activeApps = Object.assign({}, state.activeApps);
      delete activeApps[appId];
      return { ...state, securityGroup, activeApps };
    }

    case FORM_CHANGE: {
      let { meta } = action;
      if (!meta || !meta.form)
        return state;
      if (meta.form !== "createSecurityGroup")
        return state;
      let prop = meta.field;
      let updatedSecurityGroup = Object.assign({}, state.securityGroup);
      updatedSecurityGroup[prop] = action.payload;
      return { ...state, securityGroup: updatedSecurityGroup };
    }

    default:
      return state;
  }
}

//given the usersToPut in the specified role, removes users from roles outside of specified role and joins them into the specified role
const getSecurityGroupsWithUpdatedUsers = (id, roles, usersToPut) => {
  return roles.map(role => {
    let filteredRoleUsers = role.users.filter(user => !usersToPut.some(userToPut => userToPut.userId === user.userId));
    //joins specified role's users with the usersToPut array and deduplicates them
    if (role.id === id) {
      return { ...role, users: _.uniqBy([...usersToPut, ...role.users], 'userId') };
    }
    else if (filteredRoleUsers.length !== role.users.length) {
      return { ...role, users: filteredRoleUsers };
    }
    else {
      return role;
    }
  });
}
